<template>




    <div class="row">  
                    


        <div class="col-lg-12">
            <h3 class="entry-title"> <i class="fas fa-lock"></i> Weryfikacja konta Transactionlink </h3>   
        </div> 


        <div class="wrap column row justify-content-between d-md-flex">
            

           <transactionlink-widget/>
        
        </div>

    </div>





</template>

<script>

    
    //import { bus } from './main';    

    // sha256
    //import sha256 from 'crypto-js/sha256';


    export default {
     
       name: 'TransactionlinkView',

        data(){

            return {

              modal: null,

              details: '',



              waitCount: 0
              
            }
       },


       methods: {


            gotomain(){


                this.$router.push({path: '/'});

            },



            onWaiting( endpoint='application' ) {


              var page = this.$root.mainpage,
                  step,


                poll = () => {

                  if (this.waitCount > 60) {

                    page.isLoading =false;

                    this.$router.push({path: 'pending'});
                    return;
                  }

                  this.waitCount++;


                  this.get( '/' + endpoint )
                      .then(response => {
                       

                        if (!!response.data) {

                          step = response.data.hasOwnProperty('step') ? response.data.step : '';


                          !step.match(/wait|kontomatik/) 
                            && this.log( 'transactionlink done - status polling done, go to ' + step );

        //console.log(step);

                          switch (step) {

                            case 'kontomatik':
                            case 'wait':
                              break;


                            case 'counteroffer':

                              page.isLoading =false;

                              // gtag
                              /*dataLayer.push({
                                event: 'verification_success',                    
                                loan_amount: this.loanAmount,
                                user_email: SHA256(this.form.client_email),
                                user_phone: SHA256(this.form.client_cellphone)
                              });*/


                              this.finishDate = response.data.last_installment_date.split(' ')[0].replace(/([0-9]{4})-([0-9]{2})-([0-9]{2})/, '$3.$2.$1');
                              this.setValues(response.data.net_amount);


                              this.$router.push({path: 'proposal'});
                              break;

                                               

                            case 'reject':
                                page.isLoading =false;

                              // gtag
                              /*dataLayer.push({
                                event: 'verification_failed',                    
                                loan_amount: this.loanAmount,
                                user_email: sha256(this.form.client_email),
                                user_phone: sha256(this.form.client_phone)
                              });*/

                              this.$router.push({path: 'rej'});
                              return;



                            case 'redirect':

                              page.isLoading =false;


                              this.$router.push({path: 'redirect'});
                              return;



                            case 'amodit':
                              page.isLoading=false;

                              let url = response.data.step_details.split('/');

                              window.location = this.getConf('amoditSignUrl') + url[ url.length - 2 ] + '%2F' + url[ url.length - 1 ];
                              return;


                            default:
                              page.isLoading =false;
                              this.$router.push({path: 'thankyou'});
                              return;
                          }


        //console.log(response.data)

                       
                        }
                        else {
                          console.log('status empty body');
                        }


                        // dispatch another poll request
                        page.isLoading
                          && setTimeout(poll, 3000);                



                      })
                      .catch(error => {
                       
                          // wait for timeout
                          //page.isLoading = false;
                          setTimeout(poll, 3000);

             
                          // Error 
                          if (error.response) {
                         

                          } else if (error.request) {
                            
                          } else {
                              // Something happened in setting up the request and triggered an Error
                              //console.log('Error', error.message);
                          }
                      });


                };


                // log 
                this.log( 'transactionlink done - status polling start' );


                // initial polling
                setTimeout(poll, 3000);
            }


            
       },


       created(){

        

       },
 

       mounted() {

        // load transactionlink script
            let widgetLib = document.createElement('script');
            widgetLib.setAttribute('src', this.getConf('transactionlinkLib'));
            document.head.appendChild(widgetLib);


            var page = this.$root.mainpage,
                me = this,
                t10lEventFired = false;


//console.log('t10l created');

            me.log( 'transactionlink page visible, token ', page.workflow_token );


            window.transactionlink_ready = function(){

//console.log('t10l ready', page);


                if (!page.workflow_token) {


                    // no workflow token
                    me.gotomain();

                    me.log('workflow_token missing, go to mainpage');

                    return;
                }


                transactionlink.setWorkspaceKey(me.getConf('transactionlinkWorkspaceKey'));
                transactionlink.setContext(page.workflow_token);

                me.getConf('transactionlinkMode') && transactionlink.setMode("sandbox");


                transactionlink.on("workflow-finished", (event) => {



                    // log 
                    me.log( 'transactionlink workflow finish' );


                    //console.log('workflow finished');

                   // console.log(event)

                    if (!t10lEventFired) {

                        t10lEventFired = true;


                        page.isLoading = ['Analizujemy Twój wniosek...', 'Weryfikacja może potrwać do minuty...', 'Proszę nie zamykać przeglądarki...'];
                        me.waitCount = 0;


                        me.post( '/transactionlink', {
                              "loan_id": page.loanId,
                              "t10l":  page.party_id + ',' + event.workflowId
                          
                            })
                          .then(response => {

                            if (!!response.data) {

                              let ok = !(response.data.IS_ERROR | 0);

                              me.onWaiting();              

                            }           
                          })
                          .catch(error => {

                                t10lEventFired = false;
                         
                              // Error 
                              if (error.response) {           
                                 console.log(error.response);
                              }                                  
                          });


                    }

                });



                // log 
                me.log( 'transactionlink workflow start' );


                window.transactionlink.open();
            }







/*
        
            _t10l.ready(function() {

                _t10l.show();

                _t10l.navigateToApp('openBankingAisIdentity');


                // listen on the command success
                _t10l.on('commandSucceded', (command) => {


                    if (command.app === 'AIS' && command.commandType === 'DATA_DOWNLOAD_COMPLETED') {
                        // data downloaded veriff will now be available in the REST API

                        _t10l.hide();

                        var page = me.$root.mainpage;

                        page.isLoading = ['Analizujemy Twój wniosek...', 'Weryfikacja może potrwać do minuty...', 'Proszę nie zamykać przeglądarki...'];
                        me.waitCount = 0;


                        me.post( '/transactionlink', {
                              "loan_id": page.loanId,
                              "t10l":  command.partyId + ',' + command.customerId
                          
                            })
                          .then(response => {

                            if (!!response.data) {

                              let ok = !(response.data.IS_ERROR | 0);

                              me.onWaiting();              

                            }           
                          })
                          .catch(error => {
                         
                              // Error 
                              if (error.response) {           
                                 console.log(error.response);
                              }                                  
                          });

                    }
                })
            });

*/






/*setTimeout(() => {
     
 var elems = document.getElementsByTagName('iframe');

                for (var i = 0; i<elems.length; i++) {
                   
                        elems[i].style.maxWidth = 'auto';
                    
                }




    }, 500);

          */ 


          // scroll to top
          this.pageTop();

       }



        
    }
</script>



<style scoped>

h3 i {
    color: #0bc268;
}

.entry-title {


    font-size:32px;
    margin: 2.8em 0 2em;

    text-align: center;

}







</style>


// WEBPACK FOOTER //
// src/TransactionlinkView.vue